export const CONTACT_PHONE = "+1 647-779-6780";
export const CONTACT_EMAIL = "parthpadhiyar31@gmail.com";

// To update resume: replace public/assets/ParthPadhiyarResume.pdf and push.
// Or swap this URL for a Google Drive direct-download link and skip the file entirely:
// "https://drive.google.com/uc?export=download&id=YOUR_FILE_ID"
export const RESUME_URL = "assets/ParthPadhiyarResume.pdf";
